<template>

  <div>
    <slot name="trigger">
        <button type="button" :class="triggerClasses" @click="trigger" v-if="showTrigger">
          <i v-if="triggerIcon !== null" class="material-icons">{{triggerIcon}}</i>
          {{ triggerText }}
        </button>
    </slot>
    <div
        ref="modalElement"
        :class="classes"
    >
      <div class="modal-header">
        <slot name="header"></slot>
      </div>
      <div class="modal-content">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <slot name="footer">

        </slot>
        <button
            v-if="showCloseModal"
            :class="closeClasses"
            @click="close">
          <i v-if="closeIcon !== null" class="material-icons">{{closeIcon}}</i>
          {{ closeText }}
        </button>
      </div>
    </div>
  </div>


</template>

<script>
export default {
  name: "MaterializecssModal",

  props: {
    type: {
      type: String,
      required: false,
      default: ''
    },

    otherClasses: {
      required: false,
      default: function () {
        return []
      },
      type: Array,
    },

    parentClasses: {
      required: false,
      default: function () {
        return []
      },
      type: Array,
    },

    otherOptions: {
      required: false,
      default: function () {
        return {}
      },
      type: Object
    },

    opened: {
      required: false,
      default: false,
      type: Boolean
    },

    triggerIcon: {
      required: false,
      default: null,
      type: String,
    },

    triggerText: {
      required: false,
      default: 'Apri',
      type: String,
    },

    triggerClasses: {
      required: false,
      default: function() { return ['btn']},
      type: Array
    },

    showTrigger: {
      required: false,
      default: true,
      type: Boolean,
    },

    showCloseModal: {
      required: false,
      default: true,
      type: Boolean,
    },

    closeIcon: {
      required: false,
      default: null,
      type: String,
    },

    closeText: {
      required: false,
      default: 'Close',
      type: String,
    },

    closeClasses: {
      required: false,
      default: function() { return ['btn']},
      type: Array
    },
  },

  data() {
    return {
      modalInstance: null,
      openState: false,
      defaultOptions: {
        onOpenStart: this.onOpenStart,
        onOpenEnd: this.onOpenEnd,
        onCloseStart: this.onCloseStart,
        onCloseEnd: this.onCloseEnd,
      }
    }
  },

  watch: {
    opened: function (oldValue, newValue) {
      if (oldValue === newValue) {
        console.log('ma cosa fai qui');
        return;
      }

      if (newValue && this.openState !== newValue) {
        this.open();
      } else if (!newValue && this.OpenState !== newValue) {
        this.close();
      }
    },
  },

  computed: {
    classes: function () {
      let classes = [
        'modal',
        ...this.otherClasses,
      ];

      switch (this.type) {
        case 'bottom-sheet':
          classes.push('bottom-sheet');
          break;
        case 'fixed-footer':
          classes.push('fixed-footer');
          break;
        default:
          break;
      }

      return classes;
    },

    options: function () {
      return {
        ...this.defaultOptions,
        ...this.otherOptions,
      }
    }
  },

  methods: {
    onOpenStart: function (evt) {
      // console.log('On open start', evt);
      this.$emit('openStart', evt);
    },

    onOpenEnd: function (evt) {
      // console.log('On open end', evt);
      this.$emit('openEnd', evt);
    },

    onCloseStart: function (evt) {
      // console.log('On close start', evt);
      this.$emit('closeStart', evt);
    },

    onCloseEnd: function (evt) {
      // console.log('On close end', evt);
      this.$emit('closeEnd', evt);
      this.openState = false;
    },

    open() {
      this.modalInstance.open();
      this.openState = true;
    },

    close() {
      this.modalInstance.close();
      this.openState = false;
    },

    trigger() {
      // console.log('trigger was triggered');
      if (this.openState) {
        this.close();
      } else {
        this.open();
      }
    }
  },

  mounted() {
    if (this.parentClasses.length > 0) {
      for (let classToAdd of this.parentClasses) {
        this.$el.classList.add(classToAdd);
      }
    }
    this.modalInstance = M.Modal.init(this.$refs.modalElement, this.options);
    if (this.opened) {
      this.open();
    }
  }
}
</script>

<style scoped>

</style>
